export const SERVER_LOCATION = `${process.env.REACT_APP_HOST}/api`

export const DRAWER_WIDTH = 225

export const SESSION_KWIKAPI_TOKEN = "@accessToken"
export const SESSION_USER = "@user"

export const SUPPORT_EMAIL = "suporte@instant.com.br"
